import { useContext } from "react";
import search from "../../assets/search.svg";
import searchdark from "../../assets/searchdark.svg";
import { InputContext } from "../../context/input.context";
import { ModeContext } from "../../context/mode.context";
import "./search-box.component.scss";

const SearchBox = () => {
  const { input, setInput } = useContext(InputContext);
  const { mode } = useContext(ModeContext);

  const inputHandler = (e) => {
    const { value } = e.target;
    return setInput(value);
  };

  return (
    <div className={`search-box ${mode ? `search-box-dark` : ``}`}>
      <div className="search-box__img">
        <img
          src={mode ? searchdark : search}
          className="search-box__img--svg"
          alt="Search SVG"
        />
      </div>
      <input
        type="text"
        className={`search-box__input ${mode ? `search-box-dark__input` : ``}`}
        onChange={inputHandler}
        value={input}
        placeholder="Search for a country..."
      />
    </div>
  );
};

export default SearchBox;
